export default __webpack_public_path__ + "static/media/dehuv.b175eff7.mp4";